import axios, { AxiosResponse } from 'axios';
import { TemperatureProfile } from 'views/site-settings/features/general-settings/types/temperature-profile.type';

// GET
// /ewosapi/v1/site-settings/{globalSiteId}/averagetemp/years
// Returns available years for average temperature data for site.
export const getAverageTempYears = async (globalSiteId: string): Promise<number[]> => {
  const res = await axios.get<number[]>(`/ewosapi/v1/site-settings/${globalSiteId}/averagetemp/years`);
  return res.data;
};

// GET
// /ewosapi/v1/site-settings/{globalSiteId}/averagetemp
// Returns site average temperature data for a number of years.
export const getAverageTemp = async (globalSiteId: string, years: number[]): Promise<TemperatureProfile[]> => {
  let params = '';
  for (let index = 0; index < years.length; index++) {
    const element = years[index];
    console.log({ index, element, length: years.length });

    if (index < years.length - 1) {
      params += `years=${element}&`;
    } else {
      params += `years=${element}`;
    }
  }
  const res = await axios.get<TemperatureProfile[]>(`/ewosapi/v1/site-settings/${globalSiteId}/averagetemp?${params}`);
  return res.data;
};

// GET
// /ewosapi/v1/site-settings/{globalSiteId}/temperatureprofile
// Gets the temperature profile for the site.
export const getTemperatureProfile = async (globalSiteId: string): Promise<TemperatureProfile[]> => {
  const res = await axios.get<TemperatureProfile[]>(`/ewosapi/v1/site-settings/${globalSiteId}/temperatureprofile`);
  return res.data;
};

// PUT
// /ewosapi/v1/site-settings/{globalSiteId}/temperatureprofile
// Sets the temperature profile for the site.
export const putTemperatureProfile = async (globalSiteId: string, request: TemperatureProfile[]): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v1/site-settings/${globalSiteId}/temperatureprofile`, request);
};
